import { render, staticRenderFns } from "./ProcessApproval.vue?vue&type=template&id=2d9c2f82&scoped=true&"
import script from "./ProcessApproval.vue?vue&type=script&lang=js&"
export * from "./ProcessApproval.vue?vue&type=script&lang=js&"
import style0 from "./ProcessApproval.vue?vue&type=style&index=0&id=2d9c2f82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c2f82",
  null
  
)

component.options.__file = "ProcessApproval.vue"
export default component.exports